"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormInputPrefix", {
    enumerable: true,
    get: function() {
        return FormInputPrefix;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _FormInputXFix = require("./FormInputXFix");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormInputPrefix = /*#__PURE__*/ _react.default.forwardRef((props, ref)=>/*#__PURE__*/ _react.default.createElement(_FormInputXFix.FormInputXFix, {
        type: "prefix",
        ...props,
        ref: ref
    }));
FormInputPrefix.displayName = "FormInputPrefix";

//# sourceMappingURL=FormInputPrefix.js.map